module.exports = __webpack_public_path__ + "static/media/sRGB_IEC61966-2-1_no_black_scaling.ce7471da.icc";